import { render, staticRenderFns } from "./ingredient.vue?vue&type=template&id=168ec840&"
import script from "./ingredient.vue?vue&type=script&lang=js&"
export * from "./ingredient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports